import { render, staticRenderFns } from "./knxsrdb.vue?vue&type=template&id=4fd263ea&scoped=true"
import script from "./knxsrdb.vue?vue&type=script&lang=js"
export * from "./knxsrdb.vue?vue&type=script&lang=js"
import style0 from "./knxsrdb.vue?vue&type=style&index=0&id=4fd263ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd263ea",
  null
  
)

export default component.exports